// import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
// import { clients } from '../../../util/clients';

// const { backend } = clients.direct;

const FeeTypesData = [
  {
    _id: 1,
    feeNumber: 245,
    description: 'description 1',
    toUnit: 23,
  },
  {
    _id: 2,
    feeNumber: 245,
    description: 'description 2',
    toUnit: 23,
  },
  {
    _id: 3,
    feeNumber: 245,
    description: 'description 3',
    toUnit: 23,
  },
  {
    _id: 4,
    feeNumber: 245,
    description: 'description 4',
    toUnit: 23,
  },
  {
    _id: 5,
    feeNumber: 245,
    description: 'description 5',
    toUnit: 23,
  },
  {
    _id: 6,
    feeNumber: 245,
    description: 'description 6',
    toUnit: 23,
  },
  {
    _id: 7,
    feeNumber: 245,
    description: 'description 7',
    toUnit: 23,
  },
  {
    _id: 8,
    feeNumber: 245,
    description: 'description 8',
    toUnit: 23,
  },
  {
    _id: 9,
    feeNumber: 245,
    description: 'description 9',
    toUnit: 23,
  },
  {
    _id: 10,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 11,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 12,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 13,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 14,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 15,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 16,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 17,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
  {
    _id: 18,
    feeNumber: 245,
    description: 'description 10',
    toUnit: 23,
  },
];

export const FeeTypes = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    loadFeeTypesRecords({ commit }, { baseCrudKey }) {
      const response = FeeTypesData;
      const withPostProcess = [...response];
      commit('base/crud/setItems', [baseCrudKey, withPostProcess], { root: true });
    },
  },
};

export default FeeTypes;
